import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { GlobalServiceProvider } from '../global-service/global-service';
/*
  Generated class for the FcmServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FmcServiceProvider {
  baseUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;
  constructor(public http: Http, public globalServiceProvider: GlobalServiceProvider) {
    console.log('Hello FcmServiceProvider Provider');
  }

  getfmcSchedule(date: string, customer: string) {
    console.log('date:', date);
    return this.http
      .get(this.baseUrl +  '/api/schedules/customer/', { params: { date: date, customer: customer } })
      .toPromise()
      .then(data => {
        let result = data.json();
        return result;
      })
      .catch(
        err => {
          return null;
        }
      );
  }

  getfmcScheduleAll(date: string, customer: string) {
    console.log('date:', date);
    return this.http
      .get(this.baseUrl +  '/api/schedules/customer/all', { params: { date: date, customer: customer } })
      .toPromise()
      .then(data => {
        let result = data.json();
        return result;
      })
      .catch(
        err => {
          return null;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/providers/fmc-service/fmc-service.ts